/**
 * Domain-based Access Control for Black Matte VTC Platform
 *
 * Domain architecture:
 * - blackmatte.fr → Public website (customer booking interface)
 * - admin.blackmatte.fr → Admin dashboard (internal administration)
 */

export const isDevelopment = () => {
  const hostname = window.location.hostname;
  return (
    hostname === 'localhost' ||
    hostname === '127.0.0.1' ||
    hostname.includes('.local')
  );
};

export const isAdminDomain = () => {
  const hostname = window.location.hostname;
  if (isDevelopment()) return true;
  return hostname === 'admin.blackmatte.fr' || hostname.startsWith('admin.');
};

export const isPublicDomain = () => {
  const hostname = window.location.hostname;
  if (isDevelopment()) return true;
  return hostname === 'blackmatte.fr' ||
    (hostname.includes('blackmatte.fr') && !hostname.startsWith('admin.'));
};

export const getDomainType = () => {
  if (isDevelopment()) return 'development';
  if (isAdminDomain()) return 'admin';
  if (isPublicDomain()) return 'public';
  return 'unknown';
};

export const ADMIN_ONLY_ROUTES = ['/admin', '/admin/login'];
export const PUBLIC_ONLY_ROUTES = ['/', '/services', '/entreprises', '/reserver', '/contact', '/payment/success'];
export const SHARED_ROUTES = ['/driver', '/driver/login', '/company/login', '/company/dashboard', '/tracking', '/legal', '/mentions-legales', '/confidentialite'];

export const isRouteAccessible = (pathname) => {
  if (isDevelopment()) return true;
  if (isPublicDomain()) {
    if (ADMIN_ONLY_ROUTES.some(route => pathname.startsWith(route))) return false;
  }
  if (isAdminDomain()) {
    const isPublicRoute = PUBLIC_ONLY_ROUTES.some(route => pathname === route || pathname.startsWith(route + '/'));
    if (isPublicRoute && pathname !== '/') return false;
  }
  return true;
};

export const getRedirectUrl = (pathname) => {
  if (isDevelopment()) return null;
  if (isPublicDomain() && ADMIN_ONLY_ROUTES.some(route => pathname.startsWith(route))) {
    return `https://admin.blackmatte.fr${pathname}`;
  }
  if (isAdminDomain() && pathname === '/') return '/admin/login';
  if (isAdminDomain() && PUBLIC_ONLY_ROUTES.some(route => pathname === route || pathname.startsWith(route + '/'))) {
    return `https://blackmatte.fr${pathname}`;
  }
  return null;
};

export const getDomainInfo = () => ({
  hostname: window.location.hostname,
  pathname: window.location.pathname,
  domainType: getDomainType(),
  isDevelopment: isDevelopment(),
  isAdminDomain: isAdminDomain(),
  isPublicDomain: isPublicDomain(),
});

export default {
  isDevelopment, isAdminDomain, isPublicDomain, getDomainType,
  isRouteAccessible, getRedirectUrl, getDomainInfo,
  ADMIN_ONLY_ROUTES, PUBLIC_ONLY_ROUTES, SHARED_ROUTES,
};
